import { render, staticRenderFns } from "./ConnectSuccess.vue?vue&type=template&id=70cedb9e&scoped=true&"
import script from "./ConnectSuccess.vue?vue&type=script&lang=js&"
export * from "./ConnectSuccess.vue?vue&type=script&lang=js&"
import style0 from "./ConnectSuccess.vue?vue&type=style&index=0&id=70cedb9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cedb9e",
  null
  
)

export default component.exports